<template>
  <KioskCenteredLayout>
    <HelpModal />
    <BaseButton :class="$style.closeBtn"
                button-style="Main">Close</BaseButton>
  </KioskCenteredLayout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import KioskCenteredLayout from '@/layouts/KioskCenteredLayout';
import BaseButton from '@/components/BaseButton';
import HelpModal from '@/components/HelpModal';

/**
 * Provide help message
 */
@Component({
  components: {
    KioskCenteredLayout,
    BaseButton,
    HelpModal,
  },
})
export default class KioskHelpMessage extends Vue {}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';

.closeBtn {
  margin-top: 62px;
  padding: 31px 110px;
  div {
    font-size: 30px;
    line-height: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskHelpMessage.vue